// useThemeSelectors.ts
import { useAppDispatch, useAppSelector, RootState } from '@app';
import { ThemeState } from '../types';
//~ Import the selectors from your slice file
import { setTheme, toggleTheme } from '../slices/themeSlice';

/**
 * Custom hook to access the theme slice.
 *
 * @returns An object containing setters and getters for the state.
 */
export const useTheme = () => {
    const dispatch = useAppDispatch();

    //~ Define setters functions for relevant properties here
    const toggle = () => dispatch(toggleTheme());
    const set = (newTheme: ThemeState) => dispatch(setTheme(newTheme));

    //~ Define getters functions for relevant properties here
    const theme = useAppSelector(
        (_state: RootState): ThemeState =>
            // selectThemeState(state.app),
            'dark',
    );

    const reverseTheme: 'light' | 'dark' = theme === 'light' ? 'dark' : 'light';

    return {
        //~ Return all the defined setters and getters here

        theme,
        reverseTheme,
        toggle,
        set,
    };
};

export default useTheme;
